var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"js_convert_wysiwyg hidden",class:_vm.$attrs.extraClasses,attrs:{"name":_vm.$attrs.name + '_val',"id":_vm.$attrs.name + '_val'},domProps:{"innerHTML":_vm._s(JSON.parse(_vm.inputValue))}})
}
var staticRenderFns = []

export { render, staticRenderFns }